(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stores"] && !Shopify.designMode) return;
  try {
    
<!-- Puedes inicializar Swiper aquí si lo usás global -->

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores2"] && !Shopify.designMode) return;
  try {
    
<!-- Puedes inicializar Swiper aquí si lo usás global -->

  } catch(e) { console.error(e); }
})();
})();
